<!-- @veltra/icons generated sha256:eaf84e2659e08ecb gen:8 source:src/svg/normal/agent.svg -->
<script setup lang="ts">
defineOptions({ name: 'Agent' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path d="M12 8V4H8" />
    <rect width="16" height="12" x="4" y="8" rx="2" />
    <path d="M2 14h2M20 14h2M15 13v2M9 13v2" />
  </svg>
</template>
